var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfiledropdownLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sign-out-alt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.386,
    viewBox: "0 0 18 18.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54375",
    "data-name": "Path 54375",
    d: "M18.986,9.074,15.194,5.282,14.111,6.368l3.294,3.294H6.617v1.532H17.406l-3.294,3.294,1.083,1.083,3.792-3.792a1.915,1.915,0,0,0,0-2.709Z",
    transform: "translate(-1.548 -1.236)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54376",
    "data-name": "Path 54376",
    d: "M8.025,16.088a.766.766,0,0,1-.766.766H2.3a.766.766,0,0,1-.766-.766V2.3A.766.766,0,0,1,2.3,1.532H7.259a.766.766,0,0,1,.766.766V6.384H9.558V2.3A2.3,2.3,0,0,0,7.259,0H2.3A2.3,2.3,0,0,0,0,2.3V16.088a2.3,2.3,0,0,0,2.3,2.3H7.259a2.3,2.3,0,0,0,2.3-2.3V12H8.025Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledropdownLogout);
export default __webpack_public_path__ + "static/media/profiledropdown-logout.b8be7cf2d61ab745fbb8c43a12e38cb5.svg";
export { ForwardRef as ReactComponent };